import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import * as Objects from '@core/objects';

import { FieldSubmissionValueInterface, FieldSubmissionResponseInterface } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

// PROJECT CUSTOM FORMS ACTIONS
/**
 * In this action creator:
 * - props<{ forms: Form[] }>() specifies the shape of the payload that the action will carry.
 * - forms is defined as a property of the action’s payload with a specific type (Form[]).
 */
// loading forms
export const LoadForms = createAction(
    '[ProjectsForms]  GET - Obtain all project forms');
export const LoadFormsSuccess = createAction(
    '[ProjectsForms]  GET - Obtain all project forms Success', props<{ forms: Objects.CustomFormSubmission[] }>());
export const LoadFormsFailure = createAction(
    '[ProjectsForms]  GET - Obtain all project forms Failure', props<{ error: HttpErrorResponse }>());

export const UpdateForms = createAction(
    '[ProjectsForms]  GET - Obtain an updated version all project by id', props<{projectId: number, event: string}>());

// Load fields of a form to state
export const LoadFieldSubmissions = createAction(
    '[ProjectsForms] - GET Form Fields Submissions', props<{ formId: string }>());
export const LoadFieldSubmissionsSuccess = createAction(
    '[ProjectsForms] - GET Form Fields Success', props<{ formId: string, fields: Objects.CustomFormFieldSubmission[] }>());
export const LoadFieldSubmissionsFailure = createAction(
    '[ProjectsForms] - GET Form Fields Failure', props<{ formId: string, error: HttpErrorResponse }>());

// Values Management
export const SetFieldValue = createAction(
    '[ProjectsForms] - Set Field Value in store', props<{ formId: string, value: FieldSubmissionValueInterface }>());

// Values submit Management
export const SubmitFieldsValues = createAction(
    '[ProjectsForms] - POST Field Values', props<{ formId: string }>()); // values will be taken from store fieldValues
export const SubmitFieldsValuesSuccess = createAction(
    '[ProjectsForms] - POST Field Values Success', props<{ formId: string, response: FieldSubmissionResponseInterface }>());
export const SubmitFieldsValuesFailure = createAction(
    '[ProjectsForms] - POST Field Values Failure', props<{ formId: string, errorResponse: HttpErrorResponse }>());

// clear errors
export const ClearFormFailures = createAction(
    '[ProjectsForms] - Clear errors for a form');
export const ClearFormFieldValues = createAction(
    '[ProjectsForms] - Clear field values for a form');

